// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () { 

		const printArrow = () => {
			const submenu = document.querySelector(".submenu");
			submenu.parentNode.classList.add('after');
		}
		
		const removeAction = (e) => {
			const botonSubMenu = document.querySelector('.submenu').parentNode.querySelector('a');
			!e ? botonSubMenu.classList.remove('active') : '';
		}
		
		const activeAction = (e) => {
			removeAction(e)
			e.target.classList.add('active');
		}


		// Main Nav Dropdown
		if (window.innerWidth  > 877){
			const subNav = document.querySelector('.privary-navigation__item > .submenu');
			subNav.parentNode.classList.add('navSub');
		}else { 
			// printArrow();

			$('.submenu').hide();

			$(".privary-navigation__item > a").click((e) => {
				const el = e.target.parentNode;
				const sub = el.querySelector('.submenu');

				if (el.parentNode.classList.contains('submenu')){
					activeAction(e);
				}else if (sub) {
					e.preventDefault();
					$('.submenu').fadeIn(200);
					activeAction(e);
				}else {
					$('.submenu').fadeOut(200);
					removeAction(undefined);
				}
				
			})
		}

		$(".expand").click(function() {
			if($(this).hasClass('open')) {
			    $('#expand').slideUp();
			    $(this).removeClass('open');
			    $(this).html("Read More");
			} else {
			    $('#expand').slideDown();
			    $(this).addClass('open');
			    $(this).html("Read Less");
			}
		    return false;
		});
		$(".open-modal").click(function() {
			$('.modal').addClass('modal-show');
		    return false;
		});
		$(".modal-close").click(function() {
			$('.modal').removeClass('modal-show');
		    return false;
		});
		$(".faq-block__item").click(function() {
			if($(this).hasClass('open')) {
			} else {
				$(".faq-block__item.open .answer").slideUp();
				$(".faq-block__item").removeClass('open');
			    $(this).children('.answer').slideDown();
			    $(this).addClass('open');
			}
		    return false;
		});
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	
	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}


const closeBtn = document.querySelector('#closebtn'),
	openMenu = document.querySelector('#MenuBtn'),
	menuModal = document.querySelector('.header--mobile__right'),
	btnModal = document.querySelectorAll('.btn--modal'),
	modal = document.querySelectorAll('.modal--special');
	

openMenu && openMenu.addEventListener('click', e => menuModal.classList.remove('hideModal') )
closeBtn && closeBtn.addEventListener('click', e => menuModal.classList.add('hideModal') )

if(btnModal && btnModal.length > 0 && modal && modal.length > 0){
	btnModal.forEach(item => {
		item.addEventListener('click', (e) => {
			e.preventDefault();
			const parent = e.target.parentNode,
			modal = parent.querySelector('.modal--special');
			modal.classList.remove('inactive');
		});
	});
	

	modal.forEach(item => {
		item.addEventListener('click', (e) => {
			e.preventDefault();
			if (e.target.classList.contains('modal--special')) {
				e.target.classList.add('inactive');
			} else if (e.target.classList.contains('closeModal')) {
				e.target.parentNode.parentNode.classList.add('inactive');
			}
		} );
	});
}